import type { Product } from "@jti/magento";
import type { CampaignOrderData, CampaignOrderDataItem } from "@jti/rest-api-types";

type BuildLoyaltyCampaignOrderDataOptions = {
  cartItems: Product[];
  cartSubTotalIncludingTax?: number;
  minimumPayableAmount?: number;
};

export const buildLoyaltyCampaignOrderData = ({
  cartItems,
  cartSubTotalIncludingTax,
  minimumPayableAmount,
}: BuildLoyaltyCampaignOrderDataOptions): CampaignOrderData | undefined => {
  if (!cartItems.length || !cartSubTotalIncludingTax) {
    return undefined;
  }

  const items: CampaignOrderDataItem = {};
  cartItems.forEach((item) => {
    const categories = item.categories?.map((category) => category.uid);
    items[item.sku] = {
      ...(categories && { categories }),
      price: item.price.value,
      qty: item.quantity,
    };
  });

  return {
    ...(minimumPayableAmount ? { minimumPayableAmount } : {}),
    items,
    orderTotal: cartSubTotalIncludingTax,
  };
};
